module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/LBmO7I/media/FC-9789948757887.jpg?1720819934108",
      "alt": "This image is the cover for the book عين الجواري"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("عين الجواري\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("جرَت أحداث القصَّة في الزَّمن القديم؛ زمن الجواري.. وبطلاتها ثلاث فتيات في غاية الجمال.. تتميَّزُ كلُّ واحدة منهنَّ بصفاتٍ جميلة تميِّزها عن الأخرى.. هنَّ لؤلؤة وجمانة وصوفيا.. في بلاد بعيدة وفي ظلام دامس.. تغيَّرت الأحداث عكس ما أرادتِ الفتيات.. أرادَت كلُّ واحدة منهنَّ أن تغيِّر مِن حياتها والهرب من هذه البلاد البعيدة.. ثمَّ توالت التغيُّرات والأحداث المُثيرة في كثيرٍ من الشوق واللَّهفة على مَصير الفتيات بعد أن تفرَّقنَ.. وطرأتِ الكثير من المواقف منها؛ الحزينة والسَّعيدة.. ماذا حدث لهنَّ يا تُرى؟! وهل تغيَّرت حياتهنَّ كما أردنَ أم جرتِ الأحداث عكس ما اشتهَت أنفسُهنَّ؟")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      شيخه الجويعد\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("شيخه الجويعد حاصلة على ماجستير في التربية عضو في المجلس الاستشاري لإمارة الشارقة من 2019 - 2023 بدأت في الكتابة للطفل وصدرت لها مجموعة من قصص الأطفال كما شاركت في العديد من الجوائز وصدرت لها روايتان \"الخان في قلبي\"، و\"بوح القدر\" حاصلة على العديد من الدورات في التنمية الذاتية.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0